import { useCallback, useRef, createRef } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';

import { appStore } from '../../managers/globalState';
import globalRefs from '../../managers/globalRefs';

import Overlay from '../overlays';
import GridList from '../grid_list';
import ThumbnailLoader from '../thumbnail_loader';
import { DEM_MODELS } from '../../data/dem';

import LayerGroupSolidSVG from '../../../www/assets/images/layer_group_solid.svg';

import '../../../www/assets/css/overlays/dem.css';
import ar from '../../languages/ar';

const TITLE_TEXT = ar.dem;
const THUMB_WIDTH = 159;
const THUMB_HEIGHT = 102;
const ITEM_PADDING = 30;

const DemItem = ({ title, thumbSrc, id, onItemClick }) => {
	const containerStyle = {
		width: `${THUMB_WIDTH}px`,
		height: `${THUMB_HEIGHT}px`
	};

	return (
		<figure className='dem-item' onClick={() => onItemClick(id)}>
			<div className='image-time-container dem-image-container' style={containerStyle}>
				{thumbSrc ? <img className='thumbnail dem-thumbnail' src={thumbSrc} alt={title} /> : <div className='dem-thumbnail placeholder' />}
			</div>
			<figcaption className='dem-title'>{title}</figcaption>
		</figure>
	);
};

const DemOverlay = ({ closeOverlay }) => {
	const mainRef = useRef();
	const scrollableNodeRef = createRef();
	const { isWindows } = useSnapshot(appStore.state);

	const navToDemModel = useCallback(modelId => {
		closeOverlay(true);
		const { getManager } = globalRefs;
		getManager('scene').showDemModel(modelId);
	}, [closeOverlay]);

	const overlayComponents = (
		<>
			<Overlay.Header
				back
				onClose={closeOverlay}
				title={TITLE_TEXT}
				Icon={LayerGroupSolidSVG}
			/>
			{DEM_MODELS === null ? <ThumbnailLoader loaderText={ar.loading_model} /> : null}
			{DEM_MODELS?.length
				? (
					<div className='content-mask'>
						<GridList
							rowClassName='flex-grid-row'
							minPerRow={2}
							dataList={DEM_MODELS}
							itemSize={THUMB_WIDTH + ITEM_PADDING * 2}
							itemPadding={[ITEM_PADDING, ITEM_PADDING]}
							itemComponent={<DemItem onItemClick={navToDemModel} />}
							scrollableRef={isWindows ? scrollableNodeRef : mainRef}
						/>
					</div>
				)
				: <Overlay.NoResults />}
		</>
	);

	return (
		<Overlay type='dem' ref={mainRef}>
			{isWindows
				? (
					<SimpleBar scrollableNodeProps={{ ref: scrollableNodeRef }} style={{ height: '100%' }}>
						{overlayComponents}
					</SimpleBar>
				)
				: overlayComponents}
		</Overlay>
	);
};

DemOverlay.propTypes = {
	closeOverlay: PropTypes.func.isRequired
};

export default DemOverlay;
